import React, { useState, useEffect } from 'react'

import { Modal, Box, FormControl, Select, InputLabel, MenuItem, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import Swal from 'sweetalert2';

import axios from '../../lib/axios'
import { useStateContext } from '../../context/ContextProvider'
import Loading from '../Loading';
import { handleAxiosError } from '../../helpers/helper';


const MoveSite = ({ open, setOpen, id, _siteId, type = "sales", sites = [], isRequest = false }) => {

    const { t } = useTranslation()
    const { config } = useStateContext()

    const [siteId, setSiteId] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    /* The select can be cleared, but a move is only ever submittable with a real destination, so
     * the guard is derived straight from the current selection rather than mirrored into state -
     * there is no render where the button and the select can disagree. Landing back on the site
     * the order already sits on counts as no destination either: the request would be a no-op
     * and the backend does not reject it. */
    const disabled = !siteId || siteId == _siteId

    useEffect(() => {
        if (sites.length > 0 && _siteId) {
            setSiteId(_siteId)
        }
    }, [sites])

    const handleToggleModal = () => {
        setOpen(!open)
        setSiteId('')
    }

    const handleClear = () => {
        setSiteId('')
    }

    const moveSite = async (e) => {
        e.preventDefault()

        let url = `/api/`;
        if(type == 'sales') {
            url = url.concat(isRequest ? `shipment-requests` : `sales-orders`)
        } else if(type == 'purchase') {
            url = url.concat(isRequest ? `collection-requests` : `purchase-orders`)
        }

        url = url.concat(`/${id}/move-site`);

        setIsLoading(true);

        const formData = {};
        formData['site_id'] = siteId;

        await axios
            .put(url, formData, config)
            .then(({ data }) => {
                Swal.fire({
                    icon: "success",
                    customClass: 'success',
                    showCloseButton: true,
                    iconColor: '#00B78E',
                    text: data.success.message
                })
                setOpen(false)
            })
            .catch(({ response }) => {
                handleAxiosError({response: response})
            })
            .finally(() => {
                setIsLoading(false)
            })
    }



    return (
        <>
        {isLoading ? <Loading position='fixed' /> : ''}
        <Modal open={open} onClose={handleToggleModal}>
            <Box sx={style}>
                <div className='flex justify-between items-center p-5 w-full' style={{ backgroundColor: '#DBA34B', borderRadius: '5px 5px 0 0' }}>
                    <div className='flex items-baseline justify-between w-full'>
                        <p className='text-[18px] font-[600] text-white capitalize'>{t('move_site')}</p>
                        <div style={{ transform: "rotate(45deg)" }} className="font-[600] text-white">
                            <button onClick={handleToggleModal}><i className="fa-solid fa-plus"></i></button>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='p-5'>
                        <form className='flex justify-center flex-col items-start pt-1 pb-4'>
                            <p className="text-[14px] text-[#718096] capitalize">{t('select_site')}</p>
                            <Select
                                value={siteId}
                                onChange={e => { setSiteId(e.target.value) }}
                                sx={{
                                    width: '100%',
                                    background: '#FCFCFC',
                                    '.MuiOutlinedInput-input': {
                                        padding: '9px !important'
                                    },
                                    boxShadow: 'none',
                                    '.MuiOutlinedInput-notchedOutline': {
                                        border: '1px solid #EEEFF2 !important'
                                    },
                                    ".MuiSelect-iconOutlined": { display: siteId ? 'none !important' : '' }
                                }}
                                endAdornment={siteId ? (<IconButton sx={{ visibility: siteId ? "visible" : "hidden", padding: '0' }} onClick={handleClear}><ClearIcon /></IconButton>) : false}
                            >
                                {
                                    sites.map((item, index) => <MenuItem key={index} value={item.id}>{item.name}</MenuItem>)
                                }
                            </Select>
                        </form>
                        <div className='w-full flex gap-2 justify-between'>
                            <button type="button" onClick={handleToggleModal} className='w-full text-[14px] text-[#919399] rounded-sm px-4 py-2 bg-[#F3F5F7] hover:bg-[#E6E6E6] disabled:bg-[#B8B7BC] capitalize'>
                                {t('cancel')}
                            </button>
                            <button type="button" onClick={moveSite} disabled={disabled} className='w-full text-[14px] text-white rounded-sm px-4 py-2 bg-[#DBA34B] hover:bg-[#CF7300] disabled:bg-[#B8B7BC] capitalize'>
                                {t('select')}
                            </button>
                        </div>
                    </div>
                </div>
            </Box>
        </Modal>
        </>
    )
}

export default MoveSite

const style = {
    minWidth: "360px",
    maxWidth: "540px",
    width: "50%",
    height: "auto",
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#ffffff',
    border: 'transparent',
    borderRadius: '5px',
    boxShadow: 24,
    zIndex: "1600",
    outline: 'none'
}
